import ctl from "@netlify/classnames-template-literals";
import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { Socials } from "./socials";
import { FooterNavigation } from "./navigation";
import { Container, PLink, WalletAd } from "components";
import Logo from "svgs/parkway-dark.svg";
import { PoliciesAndCopyright } from "./policies-and-copyright";
// import { MailingList } from "../mailing-list";
import DemoInfo from "./demo-info";
import { Text } from "components/text";
import { Br } from "components/br";
import { Cookies } from "components/layout/footer/cookies";

const MainFooter = () => {
  return (
    <footer className={footerWrapStyle}>
      <Container>
        <DemoInfo />
        {/* <MailingList /> */}
        <div className={footerStyle}>
          <div className="mb-[54px] lg:mb-0">
            <PLink to="/">
              <Logo />
            </PLink>

            <Socials />
            <Text variant="p14">
              295 Herbert Macaulay way, <Br on="desktop" />
              Yaba, Lagos State.
            </Text>
            <div className={licenses}>
              {regulators.map(regulator => {
                return (
                  <div className={licensesInner}>
                    <Text variant="p14">{regulator.org}</Text>
                    {regulator.img}
                  </div>
                );
              })}
            </div>
          </div>

          <FooterNavigation />
        </div>

        <PoliciesAndCopyright />
      </Container>
      <Cookies />
      <WalletAd />
    </footer>
  );
};

const regulators = [
  {
    org: "Licensed by the CBN",
    img: (
      <StaticImage
        src="../../../assets/images/pngs/footer/Central_Bank_of_Nigeria_logo.png"
        alt="Parkway is licensed by the Central Bank of Nigeria"
      />
    ),
  },
  {
    org: "Deposits are insured by",
    img: (
      <StaticImage
        src="../../../assets/images/pngs/footer/NDIC_logo.png"
        alt="Deposits are insured by the NDIC"
      />
    ),
  },
];

const footerWrapStyle = ctl(`
mx-auto
md:pb-[76px]
py-6
bg-secondary-200

`);

const footerStyle = ctl(`
lg:flex
justify-between
pt-16
`);

const licenses = ctl(`
my-6
`);

const licensesInner = ctl(`
flex
gap-x-2
mb-4
`);

export { MainFooter };
